import React from 'react';

function PageLoader() {
    return (
        <div className="page-loader" aria-label="Loading page">
            <div className="page-loader-spinner" />
        </div>
    );
}

export default PageLoader;
